// general
import { useNavigate, useLocation } from 'react-router-dom';


// material ui
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

// icons

// components
import { CustomColorScheme } from './CustomTheme';


////////////////////////////////


export default function WeblistAppBar(props) {

  const navigate = useNavigate();
  const location = useLocation();

  // event handlers //////////////


  // render //////////////////////

  return (
    <AppBar
      position='static'
      elevation={1}
      sx={{
        backgroundColor: CustomColorScheme['blue1'],
        marginBottom: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          borderColor: CustomColorScheme['blue'],
          padding: 1,
        }}
      >
        <img
          src='rasbora133.png'
          height={40}
        />
        <Typography
          paddingLeft={1}
          fontSize={20}
        >
          Uptakeblue
        </Typography>
      </Box>
    </AppBar>
  );
}
